// constant addition
export default Object.freeze({
  ...process.env,
  SAMPLE_TEST: '',
});



// WEBPACK FOOTER //
// ./src/constants/index.js